import { Avatar, MenuProps, Dropdown } from "antd";
import { LogoutOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import UserLogo from "../../assets/Images/useravatar.jpg";

const UserProfile = () => {
  const navigate = useNavigate();
  const UserName = localStorage.getItem("UserName");
  const items: MenuProps["items"] = [
    {
      label: "Logout",
      key: "logout",
      icon: <LogoutOutlined />,
    },
  ];

  const handleMenuClick: MenuProps["onClick"] = (e) => {
    if (e.key === "logout") {
      localStorage.clear();
      navigate("/login");
    }
  };

  const menuProps = {
    items,
    onClick: handleMenuClick,
  };

  return (
    <Dropdown menu={menuProps} trigger={["click"]}>
      <div className="userprofile">
        <Avatar
          className="userprofile-avatar"
          size={40}
          gap={0}
          icon={
            <img
              src={UserLogo}
              alt={`user image`}
              style={{
                width: "100%",
                height: "100%",
                borderRadius: "50%",
              }}
            />
          }
        />
        <div style={{ display: "flex", alignItems: "center" }}>
          <strong>{UserName || "User Name"}</strong>
        </div>
      </div>
    </Dropdown>
  );
};

export default UserProfile;
